import store from '@/store';
import { CampaignModel } from '@/models/CampaignModel';
import { FlowPageDoesNotExists } from '@/exceptions/FlowPageDoesNotExists';
import { sendNoFlowPageStatusEvent } from '@/utilities/iFrameUtils';

export default function useFlow() {
  const campaignModel = store.getters['campaign/model'] as CampaignModel;
  const campaignState = campaignModel.state;

  const getNextFlowPage = (currentIndex?: number | null): number | null => {
    if (typeof currentIndex === 'undefined') {
      currentIndex = store.getters['campaign/flowIndex'] as number;
    }

    const nextFlowIndex = currentIndex === null || currentIndex === undefined ? 0 : currentIndex + 1;

    if (typeof campaignState.flowPages[Number(nextFlowIndex)] === 'undefined') {
      return null;
    }

    const nextFlowPageModel = campaignState.flowPages[Number(nextFlowIndex)];
    const nextFlowPageState = nextFlowPageModel.state;

    const condition = nextFlowPageState.config?.settings?.state.advanced?.visibilityCondition;

    if (condition && !condition.check()) {
      return getNextFlowPage(campaignModel.getFlowPageIndex(nextFlowPageModel.id));
    }

    if (nextFlowPageState) {
      return nextFlowPageState.id;
    }

    return null;
  };

  const getFirstFlowPage = (): number | null => {
    return getNextFlowPage(null);
  };

  const makeSpecificFlowPageActive = (flowId: number) => {
    if (!campaignModel.getFlowPageModel(flowId)) {
      throw new FlowPageDoesNotExists(`The requested flow page ${flowId} does not exist on the campaign.`);
    }

    store.commit('campaign/setCurrentFlowId', flowId);
  };

  const goToNextFlowPage = () => {
    const nextFlowPage = getNextFlowPage();

    if (nextFlowPage) {
      store.commit('campaign/setCurrentFlowId', nextFlowPage);
    } else {
      // No more flowpages available. Notify potential listeners outside iframe.
      store.commit('campaign/setNoMoreFlowPages', true);
      sendNoFlowPageStatusEvent();
    }
  };

  return {
    getNextFlowPage,
    makeSpecificFlowPageActive,
    getFirstFlowPage,
    goToNextFlowPage
  };
}
